'use client';

import { useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { TRACE_AGENT_NAMES } from '@terra/shared-contracts-trace';
import {
  Filter,
  useTraceAgentLabel,
  type FilterItem,
} from '@terra/ui-design-system';
import {
  isTraceAgentFilter,
  type TraceAgentFilter,
} from '../../../store/tab/tracesTabScopedFilterStore';

export function ExecutionsAgentFilter({
  value,
  onChange,
}: {
  value: TraceAgentFilter[];
  onChange: (value: TraceAgentFilter[]) => void;
}) {
  const tExecutions = useTranslations('designSystem.executions');
  const getAgentLabel = useTraceAgentLabel();
  const items = useMemo(
    (): FilterItem[] =>
      TRACE_AGENT_NAMES.map((agentName) => ({
        label: getAgentLabel(agentName) ?? agentName,
        value: agentName,
      })),
    [getAgentLabel],
  );

  return (
    <Filter
      id="execution-agent"
      density="compact"
      isMultiSelect
      placeholder={tExecutions('filters.agent')}
      items={items}
      value={value}
      onChange={(values) => onChange(values.filter(isTraceAgentFilter))}
    />
  );
}
